import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { AffinityBlacklistEntry } from "../../recommendation.types";

export const requestGetAffinityBlacklist = async (): Promise<
  AffinityBlacklistEntry[]
> => {
  return await instance.get(ApiRoutesRecommendation.AffinityBlacklist);
};
